"use client";

import { createContext, useContext, useEffect, useState } from "react";

type AuthContextType = {
  token: string | null;
  role: string | null;
  nickname: string | null;
  approved: boolean;
  loading: boolean;
  login: (
    token: string,
    role: string,
    approved: boolean,
    nickname?: string
  ) => void;
  logout: () => void;
};

const AuthContext = createContext<AuthContextType>({
  token: null,
  role: null,
  nickname: null,
  approved: false,
  loading: true,
  login: () => {},
  logout: () => {},
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [token, setToken] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);
  const [nickname, setNickname] = useState<string | null>(null);
  const [approved, setApproved] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  /* ===============================
     RESTAURA SESSÃO
  =============================== */
  useEffect(() => {
    const savedToken = localStorage.getItem("nexbid_token");
    const savedRole = localStorage.getItem("nexbid_role");
    const savedNickname = localStorage.getItem("nexbid_nickname");
    const savedApproved = localStorage.getItem("nexbid_approved");

    if (savedToken && savedRole) {
      setToken(savedToken);
      setRole(savedRole);
      setNickname(savedNickname);
      setApproved(savedApproved === "true");
    }

    setLoading(false);
  }, []);

  /* ===============================
     LOGIN
  =============================== */
  function login(
    newToken: string,
    newRole: string,
    isApproved: boolean,
    newNickname?: string
  ) {
    localStorage.setItem("nexbid_token", newToken);
    localStorage.setItem("nexbid_role", newRole);
    localStorage.setItem("nexbid_approved", String(isApproved));

    if (newNickname) {
      localStorage.setItem("nexbid_nickname", newNickname);
      setNickname(newNickname);
    }

    setToken(newToken);
    setRole(newRole);
    setApproved(isApproved);
  }

  /* ===============================
     LOGOUT
  =============================== */
  function logout() {
    localStorage.clear();
    setToken(null);
    setRole(null);
    setNickname(null);
    setApproved(false);
    window.location.href = "/login";
  }

  return (
    <AuthContext.Provider
      value={{
        token,
        role,
        nickname,
        approved,
        loading,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

